.ai{aspect-ratio:1/1;}